/* jshint esversion: 6 */
import Dot from 'dot-object';

let validate = (function() {
    var isFieldInvalid = function(field, errors) {
        return Dot.pick(field, errors) !== undefined;
    };

    var checkInvalid = function(el, binding, vnode) {
        if (vnode.context.errors && isFieldInvalid(binding.value, vnode.context.errors)) {
            el.classList.add('is-invalid');
        } else {
            el.classList.remove('is-invalid');
        }
    };

    return {
        inserted: checkInvalid,
        update: checkInvalid
    };
})();

export default validate;